import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/hola-caribe-logo.svg';
import { REGIONS, CONCIERGE, pic } from '../data/site';
import { useSite } from '../data/SiteContext';

const NAV = [
  { key:'destinations', label:'Destinations', menu:true, path:'/regions' },
  { key:'hotels', label:'Hotels', menu:false, path:'/hotels' },
  { key:'cruises', label:'Cruises', menu:true, path:'/cruises' },
  { key:'experiences', label:'Experiences & Events', menu:true, path:'/experiences' },
  { key:'guides', label:'Travel Guides', menu:true, path:'/guides' },
  { key:'travel-info', label:'Travel Info', menu:false, path:'/travel-info' },
  { key:'concierge', label:'Travel Concierge', menu:true, path:'/concierge' },
  { key:'pros', label:'For Professionals', menu:false, path:'/partners' },
  { key:'about', label:'About Us', menu:false, path:'/about' },
  { key:'contact', label:'Contact', menu:false, path:'/contact' },
];

const MOBILE_NAV = [
  { label:'Destinations', path:'/regions' },
  { label:'Hotels', path:'/hotels' },
  { label:'Cruises', path:'/cruises' },
  { label:'Experiences & Events', path:'/experiences' },
  { label:'Travel Guides', path:'/guides' },
  { label:'Travel Info', path:'/travel-info' },
  { label:'Travel Concierge', path:'/concierge' },
  { label:'For Travel Professionals', path:'/partners' },
  { label:'About Us', path:'/about' },
  { label:'Contact', path:'/contact' },
];

export default function Header() {
  const navigate = useNavigate();
  const { contact, cruises, events, dests, countryGuides } = useSite();
  const guideItems = countryGuides.filter(g => g.isActive).sort((a, b) => a.countryName.localeCompare(b.countryName)).map(g => ({ label: g.countryName, path: '/guides/' + g.key }));
  const destItems = [...dests].sort((a, b) => a.name.localeCompare(b.name)).map(d => ({ label: d.name, path: '/destinations/' + d.slug }));
  const activeEvents = events.filter(e => e.isActive);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  useEffect(() => {
    const onResize = () => {
      const m = window.innerWidth < 900;
      setIsMobile(prev => {
        if (m !== prev) setMenuOpen(false);
        return m;
      });
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const go = (path) => {
    setOpenMenu(null);
    setMenuOpen(false);
    navigate(path);
  };

  const MENUS = {
    destinations: {
      cols: [
        { title:'Regions', items: REGIONS.map(r => ({ label:r.name, path:'/regions/' + r.key })) },
        { title:'Destinations', items: destItems.slice(0, Math.ceil(destItems.length / 2)) },
        { title:' ', items: destItems.slice(Math.ceil(destItems.length / 2)) },
      ],
      feature: { title:'Where to next?', text:'Browse by region, or jump straight to one of our destinations.', img: dests[0]?.img || REGIONS[0].img, cta:'All destinations →', path:'/destinations' },
    },
    cruises: {
      cols: [{ title:'Categories', items: cruises.map(c => ({ label:c.name, path:'/cruises/' + c.id })) }],
      feature: { title:'Cruises', text:'Every way to see the world from the water.', img:cruises[0]?.img, cta:'All cruises →', path:'/cruises' },
    },
    experiences: {
      cols: [
        { title:'Events & Experiences', items: activeEvents.slice(0, 9).map(e => ({ label:e.name, path:'/experiences/' + e.key })) },
        { title:' ', items: activeEvents.slice(9, 18).map(e => ({ label:e.name, path:'/experiences/' + e.key })) },
      ],
      feature: { title:'Be there when it happens', text:'Carnival, Grand Prix, migration season — tickets and logistics handled.', img: activeEvents[0]?.img || pic('festival,carnival', 190), cta:'All experiences →', path:'/experiences' },
    },
    guides: {
      cols: [
        { title:'Country Guides', items: guideItems.slice(0, Math.ceil(guideItems.length / 2)) },
        { title:' ', items: guideItems.slice(Math.ceil(guideItems.length / 2)) },
      ],
      feature: { title:'Travel Journal', text:'Long-form stories and practical guides from our specialists.', img: dests[0]?.img || pic('travel,journal', 200), cta:'Read the journal →', path:'/blog' },
    },
    concierge: {
      cols: [
        { title:'Services', items: CONCIERGE.slice(0, 6).map(c => ({ label:c.name, path:'/concierge' })) },
        { title:' ', items: CONCIERGE.slice(6).map(c => ({ label:c.name, path:'/concierge' })) },
      ],
      feature: { title:'Travel Concierge', text:'The details that turn a good trip into an unforgettable one.', img:CONCIERGE[6].img, cta:'Explore concierge →', path:'/concierge' },
    },
  };

  const mega = MENUS[openMenu];

  return (
    <header style={{ position:'sticky', top:0, zIndex:50, padding:'14px 20px' }}>
      <div style={{ maxWidth:1240, margin:'0 auto', borderRadius:22, overflow:'hidden', boxShadow:'0 12px 30px rgba(12,43,47,0.2)' }}>
        <div style={{ display:'flex', alignItems:'center', gap:14, padding:'12px 20px', background:'linear-gradient(135deg,#26c6a3,#0e8a9c)' }}>
          <div onClick={() => go('/')} style={{ display:'flex', alignItems:'center', cursor:'pointer', marginRight:'auto' }}>
            <img src={logo} alt="HolaCaribe — happiness without borders" style={{ height:44, display:'block' }} />
          </div>
          {!isMobile && (
            <>
              <a href={contact.telLink} className="header-link">{contact.phone}</a>
              <a href={contact.igLink} target="_blank" rel="noreferrer" className="header-link">Instagram</a>
              <a href={contact.waLink} target="_blank" rel="noreferrer" className="hover-bright" style={{ display:'flex', alignItems:'center', gap:7, flexShrink:0, padding:'10px 16px', borderRadius:12, fontWeight:700, fontSize:13, color:'#fff', background:'linear-gradient(135deg,#1fbe63,#12994c)', boxShadow:'0 6px 16px rgba(18,153,76,0.35)', whiteSpace:'nowrap' }}>
                <span style={{ width:8, height:8, borderRadius:'50%', background:'#eafff2' }}></span>WhatsApp
              </a>
            </>
          )}
          {isMobile && (
            <button onClick={() => setMenuOpen(o => !o)} aria-label="Menu" style={{ display:'flex', flexDirection:'column', justifyContent:'center', gap:5, width:46, height:46, padding:'0 12px', border:'1px solid rgba(255,255,255,0.4)', borderRadius:13, background:'rgba(255,255,255,0.14)', cursor:'pointer' }}>
              <span style={{ display:'block', height:2.5, background:'#fff', borderRadius:2 }}></span>
              <span style={{ display:'block', height:2.5, background:'#fff', borderRadius:2 }}></span>
              <span style={{ display:'block', height:2.5, background:'#fff', borderRadius:2 }}></span>
            </button>
          )}
        </div>
        {!isMobile && (
          <nav style={{ display:'flex', alignItems:'center', justifyContent:'center', flexWrap:'wrap', gap:'0 4px', padding:'0 14px', background:'#ffffff', borderTop:'1px solid #e4f2ed' }}>
            {NAV.map(n => (
              <span
                key={n.key}
                className={'navlink' + (openMenu === n.key ? ' active' : '')}
                onClick={() => n.menu ? setOpenMenu(m => m === n.key ? null : n.key) : go(n.path)}
              >
                {n.label}
              </span>
            ))}
          </nav>
        )}
      </div>

      {mega && (
        <div style={{ maxWidth:1240, margin:'10px auto 0', padding:26, borderRadius:24, background:'#ffffff', border:'1px solid #d8efe8', boxShadow:'0 26px 60px rgba(12,43,47,0.22)', display:'grid', gridTemplateColumns:'1fr 300px', gap:30, animation:'floatUp .28s ease both' }}>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:24 }}>
            {mega.cols.map((col, i) => (
              <div key={i}>
                <div style={{ fontSize:11.5, fontWeight:800, letterSpacing:'.14em', textTransform:'uppercase', color:'#0e9c86', padding:'0 10px 10px', borderBottom:'1px solid #eaf6f2', marginBottom:8 }}>{col.title}</div>
                <div style={{ display:'grid', gap:1 }}>
                  {col.items.map((it, j) => (
                    <span key={j} className="mega-item" onClick={() => go(it.path)}>{it.label}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div onClick={() => go(mega.feature.path)} style={{ cursor:'pointer', borderRadius:18, overflow:'hidden', position:'relative', minHeight:230, display:'flex', flexDirection:'column', justifyContent:'flex-end' }}>
            <div className="cover" style={{ backgroundImage:`url(${mega.feature.img})`, backgroundSize:'cover', backgroundPosition:'center' }}></div>
            <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0.1) 30%,rgba(6,40,45,0.85) 100%)' }}></div>
            <div style={{ position:'relative', padding:18, color:'#fff' }}>
              <div className="serif" style={{ fontSize:23, lineHeight:1.15 }}>{mega.feature.title}</div>
              <div style={{ fontSize:13.5, lineHeight:1.5, opacity:.9, margin:'6px 0 10px' }}>{mega.feature.text}</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#ffdd55' }}>{mega.feature.cta}</div>
            </div>
          </div>
        </div>
      )}

      {isMobile && menuOpen && (
        <div style={{ maxWidth:1240, margin:'10px auto 0', padding:12, borderRadius:20, background:'linear-gradient(135deg,#26c6a3,#0e8a9c)', border:'1px solid rgba(255,255,255,0.14)', boxShadow:'0 16px 34px rgba(12,43,47,0.3)', display:'grid', gap:2, maxHeight:'74vh', overflowY:'auto' }}>
          <span className="drawer-link" onClick={() => go('/')}>Home</span>
          {MOBILE_NAV.map(n => (
            <span key={n.label} className="drawer-link" onClick={() => go(n.path)}>{n.label}</span>
          ))}
          <div style={{ display:'flex', gap:8, marginTop:6 }}>
            <a href={contact.waLink} target="_blank" rel="noreferrer" style={{ flex:1, textAlign:'center', padding:14, borderRadius:12, fontWeight:700, fontSize:15, color:'#fff', background:'linear-gradient(135deg,#1fbe63,#12994c)' }}>WhatsApp</a>
          </div>
        </div>
      )}
    </header>
  );
}
